import React from "react";
import { Spinner } from "react-bootstrap";
import "./LoadingIndicator.css";

const LABELS = {
   loading: "Loading",
   processing: "Processing",
   reconciling: "Reconciling",
};

const SIZE_CLASS = {
   sm: "loading-indicator--sm",
   md: "loading-indicator--md",
   lg: "loading-indicator--lg",
};

const BS_SIZE = {
   sm: "sm",
   md: undefined,
   lg: undefined,
};

export default function LoadingIndicator({ state = "loading", label, size = "md", className }) {
   const text = label ?? LABELS[state] ?? LABELS.loading;
   const sizeClass = SIZE_CLASS[size] ?? SIZE_CLASS.md;
   const bsSize = BS_SIZE[size];

   const wrapperClass = ["loading-indicator", sizeClass, className].filter(Boolean).join(" ");

   return (
      <div className={wrapperClass} role="status" aria-live="polite">
         <Spinner animation="border" variant="primary" size={bsSize} aria-hidden="true" />
         <span className="loading-indicator__label">{text}</span>
         <span className="visually-hidden">{text}</span>
      </div>
   );
}
